export const High5Locked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 50 50"
  >
    <g
      id="High-5_Badge_-_Locked"
      data-name="High-5 Badge - Locked"
      transform="translate(1 -5)"
    >
      <g
        id="Achievement_Icon"
        data-name="Achievement Icon"
        transform="translate(0 6)"
      >
        <circle
          id="Ellipse_40"
          data-name="Ellipse 40"
          cx="24"
          cy="24"
          r="24"
          fill="#e6e6e6"
          stroke="#666"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <g
          id="Group_2450"
          data-name="Group 2450"
          transform="translate(-7.806 -12.389)"
        >
          <g
            id="Group_2449"
            data-name="Group 2449"
            transform="translate(15.979 24.987)"
          >
            <path
              id="Path_2040"
              data-name="Path 2040"
              d="M32.521,43.841a9.359,9.359,0,0,0,5.5-1.77.678.678,0,1,0-.792-1.1,8.072,8.072,0,1,1,1.337-11.9.678.678,0,1,0,1.015-.9,9.427,9.427,0,1,0-7.061,15.673Z"
              transform="translate(-19.879 -24.987)"
              fill="#666"
            />
            <path
              id="Path_2041"
              data-name="Path 2041"
              d="M39.55,44.572h.719a.339.339,0,0,0,.339-.339V43.224a2.827,2.827,0,0,0,2.63-2.706c0-1.367-.688-2.1-2.536-2.694l-.094-.031V35.17a2.388,2.388,0,0,1,1.183.914.339.339,0,0,0,.481.084l.61-.448a.339.339,0,0,0,.078-.467,3.7,3.7,0,0,0-2.352-1.479v-.849a.339.339,0,0,0-.339-.339H39.55a.339.339,0,0,0-.339.339v.818a2.594,2.594,0,0,0-2.426,2.53c0,1.217.758,2.034,2.382,2.571l.044.015v2.991a2.867,2.867,0,0,1-1.532-1,.339.339,0,0,0-.475-.041l-.57.475a.339.339,0,0,0-.045.476,4.159,4.159,0,0,0,2.621,1.442v1.027A.339.339,0,0,0,39.55,44.572Zm1.058-5.249c.993.362,1.179.7,1.179,1.222a1.384,1.384,0,0,1-1.179,1.321Zm-2.387-3.13a1.129,1.129,0,0,1,.99-1.1v2.233C38.4,36.993,38.221,36.628,38.221,36.193Z"
              transform="translate(-27.233 -29.152)"
              fill="#666"
            />
            <path
              id="Path_2042"
              data-name="Path 2042"
              d="M57.185,38.465l-.5,4.119a.3.3,0,0,0,.181.312l.573.239a.3.3,0,0,0,.326-.065,2.4,2.4,0,0,1,1.735-.7A1.776,1.776,0,0,1,61.42,44.2a1.959,1.959,0,0,1-3.861.362.3.3,0,0,0-.349-.238l-.693.131a.3.3,0,0,0-.191.126.3.3,0,0,0-.046.224,3.064,3.064,0,0,0,3.182,2.486,3.1,3.1,0,0,0,3.283-3.128,2.975,2.975,0,0,0-3.14-3.008,3.647,3.647,0,0,0-1.488.307l.226-2.015h3.613a.3.3,0,0,0,.3-.3V38.5a.3.3,0,0,0-.3-.3H57.481A.3.3,0,0,0,57.185,38.465Z"
              transform="translate(-38.064 -32.23)"
              fill="#666"
            />
            <path
              id="Path_2043"
              data-name="Path 2043"
              d="M77.054,43.918H75.227v-1.85a.3.3,0,0,0-.3-.3h-.645a.3.3,0,0,0-.3.3v1.85H72.159a.3.3,0,0,0-.3.3v.644a.3.3,0,0,0,.3.3h1.827v1.886a.3.3,0,0,0,.3.3h.645a.3.3,0,0,0,.3-.3V45.159h1.827a.3.3,0,0,0,.3-.3v-.644A.3.3,0,0,0,77.054,43.918Z"
              transform="translate(-46.606 -34.185)"
              fill="#666"
            />
            <path
              id="Path_2044"
              data-name="Path 2044"
              d="M43.095,63.446h-7a.678.678,0,0,0,0,1.356h7a1.356,1.356,0,1,1,0,2.712h-24.4a1.356,1.356,0,1,1,0-2.712h2.034a.678.678,0,1,0,0-1.356H18.691a2.712,2.712,0,1,0,0,5.423h24.4a2.712,2.712,0,1,0,0-5.423Z"
              transform="translate(-15.979 -46.065)"
              fill="#666"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const High5Unlocked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="55"
    viewBox="0 0 50 55"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="0.5"
        x2="0.5"
        y2="1"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#d11947" />
        <stop offset="1" stopColor="#8d0034" />
      </linearGradient>
    </defs>
    <g
      id="High-5_Badge_-_Unlocked"
      data-name="High-5 Badge - Unlocked"
      transform="translate(1)"
    >
      <g
        id="Achievement_Icon"
        data-name="Achievement Icon"
        transform="translate(0 6)"
      >
        <circle
          id="Ellipse_40"
          data-name="Ellipse 40"
          cx="24"
          cy="24"
          r="24"
          stroke="#8d0034"
          strokeLinecap="round"
          strokeWidth="2"
          fill="url(#linear-gradient)"
        />
        <g
          id="Group_2450"
          data-name="Group 2450"
          transform="translate(-7.806 -12.389)"
        >
          <g
            id="Group_2449"
            data-name="Group 2449"
            transform="translate(15.979 24.987)"
          >
            <path
              id="Path_2040"
              data-name="Path 2040"
              d="M32.521,43.841a9.359,9.359,0,0,0,5.5-1.77.678.678,0,1,0-.792-1.1,8.072,8.072,0,1,1,1.337-11.9.678.678,0,1,0,1.015-.9,9.427,9.427,0,1,0-7.061,15.673Z"
              transform="translate(-19.879 -24.987)"
              fill="#fff"
            />
            <path
              id="Path_2041"
              data-name="Path 2041"
              d="M39.55,44.572h.719a.339.339,0,0,0,.339-.339V43.224a2.827,2.827,0,0,0,2.63-2.706c0-1.367-.688-2.1-2.536-2.694l-.094-.031V35.17a2.388,2.388,0,0,1,1.183.914.339.339,0,0,0,.481.084l.61-.448a.339.339,0,0,0,.078-.467,3.7,3.7,0,0,0-2.352-1.479v-.849a.339.339,0,0,0-.339-.339H39.55a.339.339,0,0,0-.339.339v.818a2.594,2.594,0,0,0-2.426,2.53c0,1.217.758,2.034,2.382,2.571l.044.015v2.991a2.867,2.867,0,0,1-1.532-1,.339.339,0,0,0-.475-.041l-.57.475a.339.339,0,0,0-.045.476,4.159,4.159,0,0,0,2.621,1.442v1.027A.339.339,0,0,0,39.55,44.572Zm1.058-5.249c.993.362,1.179.7,1.179,1.222a1.384,1.384,0,0,1-1.179,1.321Zm-2.387-3.13a1.129,1.129,0,0,1,.99-1.1v2.233C38.4,36.993,38.221,36.628,38.221,36.193Z"
              transform="translate(-27.233 -29.152)"
              fill="#fff"
            />
            <path
              id="Path_2042"
              data-name="Path 2042"
              d="M57.185,38.465l-.5,4.119a.3.3,0,0,0,.181.312l.573.239a.3.3,0,0,0,.326-.065,2.4,2.4,0,0,1,1.735-.7A1.776,1.776,0,0,1,61.42,44.2a1.959,1.959,0,0,1-3.861.362.3.3,0,0,0-.349-.238l-.693.131a.3.3,0,0,0-.191.126.3.3,0,0,0-.046.224,3.064,3.064,0,0,0,3.182,2.486,3.1,3.1,0,0,0,3.283-3.128,2.975,2.975,0,0,0-3.14-3.008,3.647,3.647,0,0,0-1.488.307l.226-2.015h3.613a.3.3,0,0,0,.3-.3V38.5a.3.3,0,0,0-.3-.3H57.481A.3.3,0,0,0,57.185,38.465Z"
              transform="translate(-38.064 -32.23)"
              fill="#fff"
            />
            <path
              id="Path_2043"
              data-name="Path 2043"
              d="M77.054,43.918H75.227v-1.85a.3.3,0,0,0-.3-.3h-.645a.3.3,0,0,0-.3.3v1.85H72.159a.3.3,0,0,0-.3.3v.644a.3.3,0,0,0,.3.3h1.827v1.886a.3.3,0,0,0,.3.3h.645a.3.3,0,0,0,.3-.3V45.159h1.827a.3.3,0,0,0,.3-.3v-.644A.3.3,0,0,0,77.054,43.918Z"
              transform="translate(-46.606 -34.185)"
              fill="#fff"
            />
            <path
              id="Path_2044"
              data-name="Path 2044"
              d="M43.095,63.446h-7a.678.678,0,0,0,0,1.356h7a1.356,1.356,0,1,1,0,2.712h-24.4a1.356,1.356,0,1,1,0-2.712h2.034a.678.678,0,1,0,0-1.356H18.691a2.712,2.712,0,1,0,0,5.423h24.4a2.712,2.712,0,1,0,0-5.423Z"
              transform="translate(-15.979 -46.065)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
      <g id="Group_2669" data-name="Group 2669" transform="translate(31)">
        <circle
          id="Ellipse_55"
          data-name="Ellipse 55"
          cx="8.5"
          cy="8.5"
          r="8.5"
          fill="#008a1c"
        />
        <g
          id="Check_Mark_-_S"
          data-name="Check Mark - S"
          transform="translate(4 5.29)"
        >
          <path
            id="Check_Mark_-_S-2"
            data-name="Check Mark - S"
            d="M9.381,2.22a.442.442,0,0,0-.639,0L3.572,7.414,1.262,5.136a.442.442,0,0,0-.631,0,.459.459,0,0,0,0,.639l2.63,2.6a.483.483,0,0,0,.32.131.459.459,0,0,0,.32-.139l5.481-5.53A.451.451,0,0,0,9.381,2.22Z"
            transform="translate(-0.502 -2.083)"
            fill="#fff"
          />
        </g>
      </g>
    </g>
  </svg>
);
